import { ChevronRight, ChevronDown } from "lucide-react";

/**
 * Step-by-step process diagram: horizontal with arrows on desktop, vertical on
 * mobile. steps: [{ title, desc?, icon? }]. Rendered as an ordered list so the
 * sequence is readable by screen readers and search engines.
 */
export default function WorkflowDiagram({ steps, dark = false, numbered = true, className = "" }) {
  const card = dark ? "bg-white/[0.04] border-white/10" : "bg-white border-slate-200";
  const title = dark ? "text-white" : "text-slate-900";
  const desc = dark ? "text-slate-400" : "text-slate-600";
  const arrow = dark ? "text-[#25D366]/70" : "text-[#25D366]";
  return (
    <ol className={`flex flex-col lg:flex-row lg:items-stretch gap-2 lg:gap-0 ${className}`}>
      {steps.map((s, i) => {
        const Icon = s.icon;
        const last = i === steps.length - 1;
        return (
          <li key={s.title} className="flex flex-col lg:flex-row items-center lg:flex-1 min-w-0">
            <div className={`relative w-full h-full rounded-2xl border p-4 lg:p-5 text-center ${card}`}>
              {numbered && (
                <span className="absolute top-2.5 left-3 text-[10px] font-bold tracking-wider text-[#25D366]">{String(i + 1).padStart(2, "0")}</span>
              )}
              {Icon && (
                <span className="mx-auto w-11 h-11 rounded-xl grid place-items-center bg-[#25D366]/10 text-[#25D366]">
                  <Icon className="w-5 h-5" aria-hidden />
                </span>
              )}
              <h3 className={`mt-3 font-display text-sm lg:text-[15px] font-semibold leading-snug ${title}`}>{s.title}</h3>
              {s.desc && <p className={`mt-1 text-xs leading-relaxed ${desc}`}>{s.desc}</p>}
            </div>
            {!last && (
              <>
                <ChevronRight className={`hidden lg:block w-5 h-5 shrink-0 mx-0.5 ${arrow}`} aria-hidden />
                <ChevronDown className={`lg:hidden w-5 h-5 shrink-0 my-0.5 ${arrow}`} aria-hidden />
              </>
            )}
          </li>
        );
      })}
    </ol>
  );
}
